module.exports = __webpack_public_path__ + "static/img/024_TO8_1492.717159d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/024_TO8_1492.jpg
// module id = /ot9
// module chunks = 0